module.exports = __webpack_public_path__ + "static/media/pages-empty.14e222f0.svg";